<template>
  <noscript>
    <img style="display:none;" src="https://score.juicyscore.com/savedata/?isJs=0"/>
  </noscript>
</template>

<script>
export default {
  name: "juicyscore",
  mounted() {
    window.juicyLabConfig = {
      nextButton: "your-next-button-id",
      stopPingButton: "your-ping-button-id",
      completeButton: " yoursubmit-button-id",
      // apiKey: "2ioRgFrYfCAuI6ZlQwlpIZgC"
      apiKey: "PvDI6QGMB8WSWEGpkahXHn97"
    };

    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = "https://score.juicyscore.com/static/js.js";
    var x = document.getElementsByTagName('head')[0];
    x.appendChild(s);
  }
}
</script>

<style scoped>

</style>